import { Link } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function ForbiddenPage() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 px-4">
      <div className="text-center max-w-sm">
        {/* Icon */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-accent-50 flex items-center justify-center">
          <i className="ri-shield-keyhole-line text-3xl text-accent-500"></i>
        </div>

        {/* Title */}
        <h1 className="text-xl font-heading font-bold text-foreground-950 mb-2">
          접근할 수 없습니다
        </h1>

        {/* Description */}
        <p className="text-sm text-foreground-500 mb-8 leading-relaxed">
          관리자 권한이 필요합니다.<br />
          이 페이지는 가족 앨범 관리자만 접근할 수 있어요.
        </p>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          {isAuthenticated ? (
            <Link
              to="/"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              홈으로 돌아가기
            </Link>
          ) : (
            <Link
              to="/login"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-login-box-line"></i>
              로그인하기
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}